import { AssessmentInterface, AssessmentState } from "module/assessment/types";

export const isAssessmentStateScheduledOrLower = (
  assessment: AssessmentInterface
): boolean =>
  [AssessmentState.initScheduled, AssessmentState.scheduled].includes(
    assessment.state
  );
